import React, { useState, useEffect, useRef } from 'react';
import Input from '../Input';
import Dropdown from '../Dropdown';
import closeIcon from '../../Assets/Icons/close.png';
import pluseIcon from '../../Assets/Icons/Pluse.png';
import uploadIcon from '../../Assets/Icons/upload.png';
import TextInput from '../TextInput';
import search from '../../Assets/Icons/search.png';
import { postData, getData } from '../../ApiServices/ApiService';
import { ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, ORG_CONFIGURATION_CONTACT_CENTER } from '../../ApiServices/BaseURL';
import { useTheme } from "../../GlobalContext/GlobalContext";
import Loader from '../Loader';
import { logFrontendException } from '../../Utils/Exception';

const ConfigurationAddNewContactModal = ({ isOpen, onClose, onValueChange, onRefresh, channelType, setSelectedDocument, documentData, handleRefreshAllTabs }) => {
  // console.log("documentData", documentData.client_id, channelType)
  const [cientName, setCientName] = useState('');
  const [name, setName] = useState('');
  const [channel, setChannel] = useState('');
  const [listName, setListName] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [email, setEmail] = useState('');
  const [opuOut, setOptOut] = useState('');
  const [showUpload, setShowUpload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [clientNameError, setClientNameError] = useState('');
  const pageName = "ContactsCenterController";
  const { setIsLoginPopup } = useTheme();

  const fileInputRef = useRef(null);

  useEffect(() => {
    if (isOpen && documentData) {
      setName(documentData.contact_name || '');

      // Channel: decide based on which field is filled
      if (documentData?.whatsapp_no) {
        setChannel('Whatsapp');
        setPhoneNo(documentData?.whatsapp_no);
      } else if (documentData.contact_no) {
        setChannel('SMS');
        setPhoneNo(documentData?.contact_no);
      } else if (documentData.email_id) {
        setChannel('Email');
        setEmail(documentData?.email_id);
      }

      setListName(documentData?.list_name || '');
      // setSearchUser(documentData?.client_names)

      // Opt Out: convert from number to "Yes"/"No"
      const opt = documentData?.opt_out === 1 ? 'Yes' : 'No';
      setOptOut(opt);

      // if (documentData?.client_names && documentData?.client_id) {
      //   const names = documentData.client_names.split(',').map(name => name.trim());
      //   const ids = documentData.client_id;

      //   if (Array.isArray(ids) && Array.isArray(names) && ids.length === names.length) {
      //     const mappedClients = ids.map((id, idx) => ({
      //       client_id: id,
      //       client_name: names[idx],
      //     }));
      //     setSelectedClients(mappedClients);
      //   }
      // }
      // if (documentData?.client_names && documentData?.client_id) {
      //   const names = documentData.client_names.split(',').map(name => name.trim());
      //   const ids = documentData.client_id;
      //   if (Array.isArray(ids) && Array.isArray(names) && ids.length === names.length) {
      //     const mappedClients = ids.map((id, idx) => ({
      //       client_id: id,
      //       client_name: names[idx],
      //     }));
      //     setSelectedClients(mappedClients);
      //   }
      // }

      if (documentData?.clients && Array.isArray(documentData.clients)) {
        setSelectedClients(
          documentData.clients.map(client => ({
            client_id: Number(client.client_id),
            client_name: client.client_name
          }))
        );
      }

    }
  }, [isOpen, documentData]);


  // useEffect(() => {
  //   if (clientName || clientType || identificationType || identificationNumber || groupClient || mobileNumber) {
  //     setShowUpload(true);
  //   } else {
  //     setShowUpload(false);
  //   }
  // }, [clientName, clientType, identificationType, identificationNumber, groupClient, mobileNumber]);

  // Reset form fields to initial values
  const resetForm = () => {
    onClose()
    setChannel('');
    setCientName('');
    setName('');
    setPhoneNo('');
    setOptOut('');
    setListName('');
    setEmail('');
    setAddContactError('');
    setListNameError('');
    setClientNameError('')
    setError('')
    setOpuOutError('')
    setChannelNameError('')
    setListError('')
    setNameError('');
    setSelectedDocument(null);
  };

  // Run resetForm when modal closes
  useEffect(() => {
    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  const handleAddClient = () => {
    const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
    const basePayload = {
      contact_name: name,
      communication_channel: channel?.toLowerCase() || "",
      list_name: listName,
      contact_no: phoneNo,
      email_id: email,
      opt_out: opuOut?.toLowerCase() === 'yes' ? 1 : 0,
      list_id: selectedList?.list_id
    };

    const clientIds = selectedClients.map((c) => c.client_id);

    const contact_list = clientIds.map((id) => ({
      ...basePayload,
      client_id: id
    }));

    const finalPayload = {
      action_type: "bulk_contacts_upload",
      emp_id_auth: storedUserInfo?.emp_id || 0, // your logged-in user ID
      contact_list
    };

    console.log("Payload to submit:", finalPayload);
  };

  const [addContactLoading, setAddContactLoading] = useState(false);
  const [addContactError, setAddContactError] = useState('');
  const [addContactSuccess, setAddContactSuccess] = useState('');
  const [nameError, setNameError] = useState('');
  const [listError, setListError] = useState('');
  const [channelNameError, setChannelNameError] = useState('');
  const [optOutError, setOpuOutError] = useState('');
  const [contactError, setContactError] = useState('');
  const [channelTypeState, setChannelTypeState] = useState(channelType);
  useEffect(() => {
    if (channel === 'Whatsapp' || channel === 'SMS') {
      setChannelTypeState(channel);
      setEmail(''); // clear email only
      setContactError('')
    } else if (channel === 'Email') {
      setChannelTypeState(channel);
      setPhoneNo(''); // clear phone only
      setContactError('')
    }
  }, [channel]);


  const addContacts = async () => {
    setAddContactLoading(true);
    const storedUserId = JSON.parse(localStorage.getItem('_userInfo_'));
    setNameError('')
    setListError('')
    setChannelNameError('')
    setOpuOutError('')
    setAddContactError('')
    setContactError('')
    try {
      if (!name) {
        setNameError('Please enter name'); return;
      }
      if (!channel) {
        setChannelNameError('Please select channel'); return;
      }
      if (!listName) {
        setListError('Please select list name'); return;
      }
      if ((channelTypeState === 'Whatsapp' || channelTypeState === 'SMS') && !phoneNo) {
        setContactError('Please select phone number');
        return;
      }
      if ((channelTypeState === 'Whatsapp' || channelTypeState === 'SMS') && phoneNo && !/^\d{10}$/.test(phoneNo)) {
        setContactError('Phone number must be exactly 10 digits');
        return;
      }

      if (channelTypeState === 'Email' && !email) {
        setContactError('Please select email id'); return;
      }
      if (channelTypeState === 'Email' && email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setContactError('Please enter a valid email ID');
        return;
      }
      if (!opuOut) {
        setOpuOutError('Please select opt out'); return;
      }

      const basePayload = {
        contact_name: name,
        communication_channel: channel?.toLowerCase() || "",
        list_name: listName,
        contact_no: phoneNo,
        email_id: email,
        opt_out: opuOut?.toLowerCase() === 'yes' ? 1 : 0,
        list_id: selectedList?.list_id
      };

      const clientIds = selectedClients.map((c) => c.client_id);

      const contact_list = [{
        ...basePayload,
        client_id: clientIds // send as an array
      }];

      const finalPayload = {
        action_type: "manual_contacts_upload",
        emp_id_auth: storedUserId?.emp_id || 0,
        contact_list
      };


      console.log("Payload to submit:", finalPayload);
      const response = await postData(ORG_CONFIGURATION_CONTACT_CENTER, finalPayload);
      const responseData = await response.json();


      if (response.status === 200 && responseData.status_code === 200) {
        if (responseData.message.toLowerCase() === "success") {
          setAddContactSuccess(responseData?.info);
          setTimeout(() => {
            onRefresh();
            onClose();
            resetForm('');
            setAddContactSuccess('');
            handleRefreshAllTabs();
          }, 3000);
        } else {
          setAddContactError(responseData?.info || "Failed to fetch  SMS list.");
          // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, "fetchSMSList", responseData || '');
        }
      } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setAddContactError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchSMSList", responseData || response || '');

      } else {
        setAddContactError(responseData?.info || "Failed to fetch  SMS list.");
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "fetchSMSList", responseData || response || '');
      }
    } catch (err) {
      setAddContactError("Network error. Please try again.");
      logFrontendException(storedUserId, pageName, "fetchSMSList-catch", err || '');
    } finally {
      setAddContactLoading(false);
    }
  };

  const updateContacts = async () => {
    setAddContactLoading(true);
    const storedUserId = JSON.parse(localStorage.getItem('_userInfo_'));
    setNameError('')
    setListError('')
    setChannelNameError('')
    setOpuOutError('')
    setAddContactError('')
    setContactError('')
    try {
      if (!name) {
        setNameError('Please enter name'); return;
      }
      if (!channel) {
        setChannelNameError('Please select channel'); return;
      }
      if (!listName) {
        setListError('Please select list name'); return;
      }
      if ((channelTypeState === 'Whatsapp' || channelTypeState === 'SMS') && !phoneNo) {
        setContactError('Please select phone number');
        return;
      }
      if ((channelTypeState === 'Whatsapp' || channelTypeState === 'SMS') && phoneNo && !/^\d{10}$/.test(phoneNo)) {
        setContactError('Phone number must be exactly 10 digits');
        return;
      }

      if (channelTypeState === 'Email' && !email) {
        setContactError('Please select email id'); return;
      }
      if (channelTypeState === 'Email' && email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setContactError('Please enter a valid email ID');
        return;
      }
      if (!opuOut) {
        setOpuOutError('Please select opt out'); return;
      }

      const basePayload = {
        contact_name: name,
        communication_channel: channel?.toLowerCase() || "",
        list_name: listName,
        contact_no: phoneNo,
        email_id: email,
        contact_id: documentData?.contact_id,
        opt_out: opuOut?.toLowerCase() === 'yes' ? 1 : 0,
        list_id: selectedList?.list_id || documentData?.list_id
      };

      // const clientIds = selectedClients.map((c) => c.client_id);
      // const clientIds = selectedClients?.length > 0
      // ? selectedClients?.map((c) => c.client_id)
      // : documentData?.client_id
      // ? [documentData.client_id]
      // : [];
      const clientIds = selectedClients?.map((c) => c.client_id) || [];

      const contact_list = [{
        ...basePayload,
        client_id: clientIds // send as an array
      }];

      const finalPayload = {
        action_type: "edit_contact",
        emp_id_auth: storedUserId?.emp_id || 0,
        contact_list
      };


      console.log("Payload to submit:", finalPayload);
      const response = await postData(ORG_CONFIGURATION_CONTACT_CENTER, finalPayload);
      const responseData = await response.json();


      if (response.status === 200 && responseData.status_code === 200) {
        if (responseData.message.toLowerCase() === "success") {
          setAddContactSuccess(responseData?.info);
          setTimeout(() => {
            onRefresh();
            onClose();
            resetForm('');
            setAddContactSuccess('');
            handleRefreshAllTabs();
          }, 3000);
        } else {
          setAddContactError(responseData?.info || "Failed to update list.");
          // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
          logFrontendException(storedUserId, pageName, "updateContacts", responseData || '');
        }
      } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        setAddContactError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true)
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "updateContacts", responseData || response || '');

      } else {
        setAddContactError(responseData?.info || "Failed to update.");
        // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
        logFrontendException(storedUserId, pageName, "updateContacts", responseData || response || '');
      }
    } catch (err) {
      setAddContactError("Network error. Please try again.");
      logFrontendException(storedUserId, pageName, "updateContacts-catch", err || '');
    } finally {
      setAddContactLoading(false);
    }
  };

  // Handle file input change
  const handleFileChange = (event) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      //console.log("Uploaded file:", files[0]);
      // Handle file upload here (e.g., upload to server or process locally)
    }
  };

  // Trigger file input click
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

const storedUserInfo = JSON.parse(localStorage.getItem('whatsAppStatus'));
const groupClientOptions = [storedUserInfo === 1 ? "Whatsapp" : null, "Email", "SMS"].filter(Boolean);

  const optOptions = ["Yes", "No",];
  const [groupClient, setGroupClient] = useState('');
  const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
  const toggleDropdown = (dropdownName) => {
    setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    setClientList([]);
  };

  const dropdownRefs = useRef({}); // Ref for dropdown

  // Handle clicks outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutside = Object.keys(dropdownRefs.current).every(
        (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
      );
      if (isOutside) {
        setOpenDropdown(null);
        setClientList([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [clientList, setClientList] = useState([]);
  const [error, setError] = useState('');
  const [searchUser, setSearchUser] = useState('');
  const [selectedClientError, setSelectedClientError] = useState('');
  const [selectedClients, setSelectedClients] = useState([]);
  const handleSearchClient = async () => {
    try {
      setError('');
      setSelectedClientError('');
      setLoading(true);
      setClientList([]);
       setOpenDropdown(null);
      // setSelectedClients([])
      if (!searchUser) {
        setError('Please enter valid text'); return;
      }
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = { emp_id_auth: storedUserInfo?.emp_id, search_type: "GENERIC", search_word: searchUser }

      //console.log('team Data', payLoad);
      // Make the API call
      const response = await postData(ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, payLoad);
      const responseData = await response.json();
      //console.log('response Data', responseData);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setClientList(responseData?.dataJ || []);
            // setSuccess(responseData?.info);
            setTimeout(() => {
              // handleClose();
              // onValueChange();
            }, 3000);
          } else {
            setError(responseData?.info || 'Failed to fetch Client. Please try again.');
          }
        } else {
          setError(responseData?.info || 'Failed to fetch Client.');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setError('Unauthorized access. Your session may have expired. Please log in again.');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setError(responseData?.info || 'Bad request. Please check the request parameters.');
        }
        setIsLoginPopup(true)
      }
      // Internal Server Error: 500
      else if (response?.status === 500) {
        setError(responseData?.info || 'Internal Server Error. Please try again later.');
      }
      // Unexpected or network-related errors
      else {
        setError('Unexpected error occurred. Please try again later.');
      }
    } catch (error) {
      // Handle various error scenarios
      if (error.response) {
        // Server responded with a status outside the 2xx range
        setError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Client. Please try again.'}`);
      } else if (error.request) {
        // Request was made but no response was received
        setError('No response received from the server. Please check your network connection and try again.');
      } else {
        // An error occurred in setting up the request
        setError(`Something went wrong while processing your request. Please check your network connection and try again.`);
      }
    } finally {
      setLoading(false);
    }
  };

  const [listNameError, setListNameError] = useState('');
  const [listNameLoading, setListNameLoading] = useState(false);
  const [listNames, setListNames] = useState([]);
  const handleListNameSearch = async () => {
    try {
      setListNameError('');
      setListNameLoading(true);
      setListNames([]);
      if (!listName) {
        setListNameError('Please enter valid text'); return;
      }
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = { emp_id_auth: storedUserInfo?.emp_id, action_type: "list_name_search", search_word: listName }

      console.log('list Data', payLoad);
      // return
      // Make the API call
      const response = await postData(ORG_CONFIGURATION_CONTACT_CENTER, payLoad);
      const responseData = await response.json();
      //console.log('response Data', responseData);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.status_code === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setListNames(responseData?.dataJ || []);
            // setSuccess(responseData?.info);
            setTimeout(() => {
              // handleClose();
              // onValueChange();
            }, 3000);
          } else {
            setListNameError(responseData?.info || 'Failed to fetch Client. Please try again.');
          }
        } else {
          setListNameError(responseData?.info || 'Failed to fetch Client.');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setListNameError('Unauthorized access. Your session may have expired. Please log in again.');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setListNameError(responseData?.info || 'Bad request. Please check the request parameters.');
        }
        setIsLoginPopup(true)
      }
      // Internal Server Error: 500
      else if (response?.status === 500) {
        setListNameError(responseData?.info || 'Internal Server Error. Please try again later.');
      }
      // Unexpected or network-related errors
      else {
        setListNameError('Unexpected error occurred. Please try again later.');
      }
    } catch (error) {
      // Handle various error scenarios
      if (error.response) {
        // Server responded with a status outside the 2xx range
        setListNameError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Client. Please try again.'}`);
      } else if (error.request) {
        // Request was made but no response was received
        setListNameError('No response received from the server. Please check your network connection and try again.');
      } else {
        // An error occurred in setting up the request
        setListNameError(`Something went wrong while processing your request. Please check your network connection and try again.`);
      }
    } finally {
      setListNameLoading(false);
    }
  };

  const handleSearchInputText = (value) => {
    setSearchUser(value);
    setClientNameError('');
    setClientList([]);
    if (!value) {
      setSearchUser('');
    }
  };
  // const isClientSelected = (clientId) => {
  //   return selectedClients.some(c => c.client_id === clientId);
  // };



  //   const handleSelectClient = (client) => {
  //   const alreadySelected = selectedClients.some(c => c.client_id === client.client_id);

  //   let updated;
  //   if (alreadySelected) {
  //     updated = selectedClients.filter(c => c.client_id !== client.client_id);
  //   } else {
  //     updated = [...selectedClients, client];
  //   }

  //   setSelectedClients(updated);
  //   // setSearchUser(updated.map(c => c.client_name).join(', ')); // Update the input with selected names
  //   setClientNameError('');
  // };

  const isClientSelected = (clientId) => {
    return selectedClients.some(c => Number(c.client_id) === Number(clientId));
  };


  const handleSelectClient = (client) => {
    const alreadySelected = selectedClients.some(
      c => Number(c.client_id) === Number(client.client_id)
    );

    let updated;
    if (alreadySelected) {
      updated = selectedClients.filter(
        c => Number(c.client_id) !== Number(client.client_id)
      );
    } else {
      updated = [...selectedClients, client];
    }

    setSelectedClients(updated);
    console.log('Selected Clients:', updated);
    setClientNameError('');
  };

  const [selectedList, setSelectedList] = useState(null);
  const [showAllClients, setShowAllClients] = useState(false);
  const handleSelectlist = (list) => {
    setSelectedList(list); // Set selected client data
    setListName(list?.list_name); // Update TextInput with the selected client's name
    setListNames([]); // Clear the dropdown
    setSelectedClientError('');
  };


  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={() => { resetForm(); onClose(); }}>
          <img src={closeIcon} alt="Close" style={styles.iconImage} />
        </button>
        <h2 className="modal-title">{documentData ? `Update Contact` : 'Add New Contact'}</h2>
        <hr className="title-divider" style={{ marginBottom: '32px' }} />
        <div className="form-grid">
          {/* <div style={styles.formGrid}>
            <div style={styles.row}> */}
          <div className="filter-field" ref={(el) => (dropdownRefs.current["clientSearch"] = el)}>
            <label>Select Client</label>
            {selectedClients.length > 0 && (
              <div style={styles.absoluteChipsContainer}>
                {(showAllClients ? selectedClients : selectedClients.slice(0, 3)).map((client) => (
                  <div key={client.client_id} style={styles.chip}>
                    {client.client_name}
                    <span
                      style={styles.removeIcon}
                      onClick={() => handleSelectClient(client)}
                    >
                      ×
                    </span>
                  </div>
                ))}
                {!showAllClients && selectedClients.length > 3 && (
                  <div
                    style={styles.moreChip}
                    onClick={() => setShowAllClients(true)}
                  >
                    +{selectedClients.length - 3} more
                  </div>
                )}
              </div>
            )}


            <TextInput
              type="text"
              placeholder="Client"
              value={searchUser}
              onChange={(e) => handleSearchInputText(e.target.value)}
              onRightClick={handleSearchClient}
              right={
                loading ? (
                  <Loader loading={loading} color={'var(--primary-loader-color)'} size='small' /> // Show loader when loading
                ) : (
                  <img src={search} alt="Search" style={{ cursor: 'pointer', height: '20px', width: '20px' }} />
                )
              }
              style={{ padding: '20px 10px' }}
              errorMessage={clientNameError || error}
              width={280}
            />
            {clientList.length > 0 && (
              <ul style={styles.dropdownList}>
                {clientList.map((client, index) => {
                  const checked = isClientSelected(client.client_id);
                  return (
                    <li
                      key={client.client_id}
                      onClick={() => handleSelectClient(client)}
                      style={{
                        ...styles.dropdownItem,
                        backgroundColor: isClientSelected(client.client_id) ? '#f0f8ff' : 'transparent',
                        borderBottom: index !== clientList.length - 1 ? '1px solid #ccc' : 'none',
                        display: 'flex',
                        alignItems: 'center',
                        padding: '8px 12px',
                        cursor: 'pointer',
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={isClientSelected(client.client_id)}
                        onChange={(e) => {
                          handleSelectClient(client);
                        }}
                        onClick={(e) => e.stopPropagation()}
                        style={{ marginRight: '10px' }}
                      />
                      {client.client_name}
                    </li>
                  );
                })}
              </ul>
            )}

          </div>
          <Input
            label="Name"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            errorMessage={nameError}
          />
          {/* </div>
            </div> */}
          {/* <div style={styles.row}> */}
          <Dropdown
            ref={(el) => (dropdownRefs.current["channel"] = el)}
            isOpen={openDropdown === "channel"}
            toggleDropdown={() => toggleDropdown("channel")}
            label="Channel"
            options={groupClientOptions}
            value={channel}
            onChange={setChannel}
            errorMessage={channelNameError}
          />
          <div className="filter-field" > {/* Add margin-bottom here */}
            <label style={{ ...styles.labaleStyle, display: "block" }}>
              List Name
            </label>
            <TextInput
              type="text"
              placeholder="Search"
              value={listName}
              onRightClick={handleListNameSearch}
              onChange={(e) => setListName(e.target.value)}
              errorMessage={listNameError || listError}
              right={
                listNameLoading ? (
                  <Loader loading={listNameLoading} color={'var(--primary-loader-color)'} size='small' /> // Show loader when loading
                ) : (
                  <img src={search} alt="Search" style={{ cursor: 'pointer', height: '20px', width: '20px' }} />
                )
              }
              style={{ padding: "20px 10px" }} // Add padding inside the TextInput
            />
            {listNames?.length > 0 && (
              <ul style={styles.dropdownList}>
                {listNames?.map((list, index) => (
                  <li
                    key={list?.contact_id}
                    onClick={() => handleSelectlist(list)}
                    style={{
                      ...styles.dropdownItem,
                      borderBottom: index !== clientList.length - 1 ? '1px solid #ccc' : 'none', // Add line below except last item
                    }}
                  >
                    {list?.list_name}
                  </li>
                ))}
              </ul>
            )}
          </div>
          {/* </div> */}
          {/* <div style={styles.row}> */}

          {
            (channelTypeState === 'Whatsapp' || channelTypeState === 'SMS') && (
              <Input
                label="Phone No"
                placeholder="Enter Phone Number"
                value={phoneNo}
                onChange={(e) => setPhoneNo(e.target.value)}
                maxLength={10}
                errorMessage={contactError}
                inputType="number"
              />
            )
          }
          {
            channelTypeState === 'Email' && (
              <Input
                label="Email ID"
                placeholder="Enter Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                errorMessage={contactError}
              />
            )
          }
          <Dropdown
            ref={(el) => (dropdownRefs.current["opuOut"] = el)}
            isOpen={openDropdown === "opuOut"}
            toggleDropdown={() => toggleDropdown("opuOut")}
            label="Opt Out"
            options={optOptions}
            value={opuOut}
            onChange={setOptOut}
            errorMessage={optOutError}
          />
          {/* </div> */}
        </div>
        {/* {showUpload && ( */}
        {/* <div style={styles.uploadContainer} onClick={handleUploadClick} onDrop={(e) => e.preventDefault()}>
            <div style={styles.uploadBox} onDragOver={(e) => e.preventDefault()}>
              <span style={styles.uploadCircle}>
              <img src={pluseIcon} alt="Plus Icon" style={styles.iconImage} />
              </span>
              <p style={styles.uploadText}>Upload Form 16 for faster onboarding, Drop here or click on upload</p>
              <img src={uploadIcon} alt="Upload Icon" style={styles.uploadIconImage} />
  
             
              <input
                type="file"
                ref={fileInputRef}
                style={styles.fileInput}
                onChange={handleFileChange}
              />
            </div>
          </div> */}
        {/* )} */}
        {/* <div className="existing-client-checkbox">
              <label style={styles.exisitingHeading}>Primary Contact?</label>
              <input type="checkbox" checked={primaryContact} onChange={(e) => setPrimartContact(e.target.checked)} />
            </div> */}
        <hr className="footer-divider" />

        <div className="button-container">
          <button
            className="add-client-button"
            onClick={documentData ? updateContacts : addContacts}
            disabled={addContactLoading}
            style={{
              paddingLeft: '30px',
              paddingRight: '30px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px', // Add spacing between text and loader
              position: 'relative',
              opacity: addContactLoading ? 0.5 : 1, // Reduce opacity when loading
              cursor: addContactLoading ? 'not-allowed' : 'pointer',
            }}
          >
            <span>{documentData ? 'Update' : 'Add'}</span>
            {addContactLoading && (
              <Loader loading={addContactLoading} color={'var(--background-color)'} size="small" />
            )}
          </button>
          <button className="cancel-button" onClick={() => { resetForm(); onClose(); }}>Cancel</button>
          {addContactError && <div className="list-error-msg" style={{ marginBottom: '1px' }}>{addContactError} </div>}
          {addContactSuccess && <div className="list-success-msg" style={{ marginBottom: '1px' }}>{addContactSuccess} </div>}
        </div>
      </div>
    </div>
  );
};

const styles = {
  uploadContainer: {
    marginTop: '20px',
    width: '97%',
  },
  uploadBox: {
    width: '100%',
    border: '1px dashed var(--web-title-text-color)',
    borderRadius: '10px',
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    cursor: 'pointer',
    boxSizing: 'border-box',
    position: 'relative', // Position relative to contain the hidden input
  },
  uploadCircle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    backgroundColor: '#f0f0f0',
  },
  plusIcon: {
    fontSize: '16px',
    color: '#333',
  },
  uploadText: {
    flex: 1,
    color: '#262626',
    fontSize: '12px',
    fontFamily: 'Roboto',
    fontWeight: 400
  },
  uploadArrow: {
    fontSize: '18px',
    color: '#555',
  },
  fileInput: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    opacity: 0,
    cursor: 'pointer',
  },
  iconImage: {
    width: '11px',
    height: '11px',
  },
  uploadIconImage: {
    width: '25px',
    height: '25px',
    marginRight: '5px'
  },
  exisitingHeading: {
    color: '#343C44',
    fontSize: '10px',
    fontWeight: 500,
    fontFamily: 'Roboto'
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "1fr", // Single-column layout by default
    gap: "20px", // Space between rows
    marginBottom: "15px",
  },
  halfWidth: {
    gridColumn: "span 1",
    width: "48%", // Half width
    marginRight: "auto", // Aligns left
    marginBottom: '17px'
  },
  fullWidth: {
    gridColumn: "span 2",
    width: "97.5%", // Full width
  },
  row: {
    display: "flex",
    // justifyContent: "space-between",
    columnGap: "80px", // Space between dropdowns
    marginBottom: "15px",
    marginRight: "auto",
    width: "100%"
  },
  labaleStyle: {
    fontSize: '12px',
    // marginBottom: '5px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    color: 'rgb(52, 60, 68)'
  },
  dropdownList: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderRadius: '4px',
    maxHeight: '200px',
    overflowY: 'auto',
    zIndex: 1000,
    padding: 0, // Remove default padding
    margin: 0, // Remove default margin
    listStyleType: 'none', // Remove the dots
  },
  dropdownItem: {
    padding: '10px',
    cursor: 'pointer',
    borderBottom: '1px solid #eee', // Default for all items
    backgroundColor: '#fff',
    hover: {
      backgroundColor: '#f0f0f0',
    },
  },
  selectedClientsContainer: {
    display: 'flex',
    flexDirection: 'row',     // Force horizontal layout
    alignItems: 'center',
    gap: '8px',
    overflowX: 'auto',        // Enable horizontal scroll if needed
    whiteSpace: 'nowrap',
    paddingBottom: '3px',
  },

  chip: {
    backgroundColor: '#e6f3ff',
    border: '1px solid #b3d9ff',
    borderRadius: '16px',
    padding: '4px 10px',
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    color: '#0077cc',
  },

  removeIcon: {
    marginLeft: '8px',
    cursor: 'pointer',
    color: '#cc0000',
    fontWeight: 'bold',
  },

  moreChip: {
    backgroundColor: '#f0f0f0',
    borderRadius: '16px',
    padding: '4px 10px',
    fontSize: '12px',
    color: '#333',
    cursor: 'pointer'
  },
  absoluteChipsContainer: {
    position: 'absolute',
    top: '-31px',
    left: 0,
    right: 0,
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    overflowX: 'auto',
    paddingBottom: '6px',
    zIndex: 2, // keeps chips on top of input
  }



}


export default ConfigurationAddNewContactModal;